import { Button, Upload } from 'antd'
import ImageCrop from 'antd-img-crop'
import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import actions from '../Redux/FileUpload/action'
import beforeUpload from './beforeUpload'
import { CameraOutlined, LoadingOutlined } from '@ant-design/icons'
import { resizeImageToJPEG } from './utility'
import { infoMessage } from 'api/global'

const FileUploader = ({
  setAvatar,
  name,
  fileData,
  form,
  loading,
  fileId,
  component,
}: any) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (fileId) {
      dispatch({
        type: actions.GET_FILE,
        fileId: fileId,
      })
    }
  }, [fileId])

  useEffect(() => {
    if (fileData) {
      form.setFieldsValue({
        photoId: fileData._id,
      })
      setAvatar(fileData.post)
      dispatch({
        type: actions.CLEAR_FILE_DATA,
      })
    }
  }, [loading])

  const handleChangeFile = async (info: any) => {
    if (info.file.status === 'uploading') {
      info.file.status = 'done'
    }

    try {
      dispatch({
        type: actions.CHANGE_FILE_TYPE,
      })
      const jpegBlob = await resizeImageToJPEG(info.file.originFileObj)

      const fileObj = new FormData()
      const jpegFile = new File([jpegBlob], `${name}.jpeg`, {
        type: 'image/jpeg',
      })

      console.log(jpegFile, 'file jpeg...')

      fileObj.append('file', jpegFile)

      let newFile = {
        title: name,
        description: 'img',
        altText: 'img',
        sourceType: 'user_profile',
      }

      console.log(fileObj, newFile, 'fileObj, newFile...')

      dispatch({
        type: actions.REQUEST_FILE_UPLOAD,
        payload: fileObj,
        newFile: newFile,
      })
    } catch (err) {
      console.log(err, 'error')
      infoMessage('Something went wrong')
    }

    // if (info.file.status === 'done') {
    //   const fileObj = new FormData()
    //   fileObj.append('file', info.file.originFileObj)
    //   console.log('originFileObj', info.file.originFileObj)
    //   let newFile = {
    //     title: name,
    //     description: 'img',
    //     altText: 'img',
    //     sourceType: 'user_profile',
    //   }

    //   dispatch({
    //     type: actions.REQUEST_FILE_UPLOAD,
    //     payload: fileObj,
    //     newFile: newFile,
    //   })
    // }
  }

  return (
    <div>
      <ImageCrop
      // beforeCrop={(image: any) => {
      //   return beforeUpload(image)
      // }}
      >
        <Upload
          onChange={handleChangeFile}
          multiple={false}
          maxCount={1}
          showUploadList={false}
        >
          {component === 'News' ? (
            loading ? (
              <LoadingOutlined />
            ) : (
              <Button
                icon={<CameraOutlined />}
                className="media-button"
              >
                photo
              </Button>
            )
          ) : (
            <div className="btstyle">
              <Button className="secondary upload">
                Upload photo
              </Button>
            </div>
          )}
        </Upload>
      </ImageCrop>
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  fileData: state.fileUpload.fileData,
  loading: state.fileUpload.loading,
})

export default connect(mapStateToProps)(FileUploader)
